/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccessRouteImport } from './routes/access'
import { Route as BlytzcollectFunnelRouteImport } from './routes/blytzcollect/funnel'
import { Route as ExampleFeedbackRouteImport } from './routes/example.feedback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRoute = AccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectFunnelRoute = BlytzcollectFunnelRouteImport.update({
  id: '/blytzcollect/funnel',
  path: '/blytzcollect/funnel',
  getParentRoute: () => rootRouteImport,
} as any)
const ExampleFeedbackRoute = ExampleFeedbackRouteImport.update({
  id: '/example/feedback',
  path: '/example/feedback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/blytzcollect/funnel': typeof BlytzcollectFunnelRoute
  '/example/feedback': typeof ExampleFeedbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/access' | '/blytzcollect/funnel' | '/example/feedback'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/access' | '/blytzcollect/funnel' | '/example/feedback'
  id:
    '__root__' | '/' | '/access' | '/blytzcollect/funnel' | '/example/feedback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessRoute: typeof AccessRoute
  BlytzcollectFunnelRoute: typeof BlytzcollectFunnelRoute
  ExampleFeedbackRoute: typeof ExampleFeedbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access': {
      id: '/access'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof AccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/funnel': {
      id: '/blytzcollect/funnel'
      path: '/blytzcollect/funnel'
      fullPath: '/blytzcollect/funnel'
      preLoaderRoute: typeof BlytzcollectFunnelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/example/feedback': {
      id: '/example/feedback'
      path: '/example/feedback'
      fullPath: '/example/feedback'
      preLoaderRoute: typeof ExampleFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRoute: AccessRoute,
  BlytzcollectFunnelRoute: BlytzcollectFunnelRoute,
  ExampleFeedbackRoute: ExampleFeedbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
